import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { initPixel, trackPageView } from './lib/pixel';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import Search from './pages/Search';
import BidFlow from './pages/BidFlow';
import BuyerDashboard from './pages/BuyerDashboard';
import Shortlist from './pages/Shortlist';
import OwnerDashboard from './pages/OwnerDashboard';
import OwnerList from './pages/OwnerList';
import NextSteps from './pages/NextSteps';
import OwnerFAQ from './pages/OwnerFAQ';
import LetterService from './pages/LetterService';
import AccountSettings from './pages/AccountSettings';
import AdminWaitlist from './pages/AdminWaitlist';
import HomeProspector from './pages/HomeProspector';
import RentalComingSoon from './pages/RentalComingSoon';
import PreferenceOnboarding from './components/PreferenceOnboarding';

function PixelTracker() {
  const location = useLocation();

  useEffect(() => {
    initPixel();
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <PixelTracker />
        <PreferenceOnboarding />
        <Nav />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/bid/:id" element={<BidFlow />} />
            <Route path="/buyer-dashboard" element={<BuyerDashboard />} />
            <Route path="/shortlist" element={<Shortlist />} />
            <Route path="/owner-dashboard" element={<OwnerDashboard />} />
            <Route path="/owner-list" element={<OwnerList />} />
            <Route path="/next-steps" element={<NextSteps />} />
            <Route path="/faq" element={<OwnerFAQ />} />
            <Route path="/letter-service" element={<LetterService />} />
            <Route path="/account" element={<AccountSettings />} />
            <Route path="/admin/waitlist" element={<AdminWaitlist />} />
            <Route path="/home-prospector" element={<HomeProspector />} />
            <Route path="/rentals" element={<RentalComingSoon />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}
